import { useEffect, useState } from 'react'
import moment from 'moment/moment'
import type { DatepickerMethodsResult, DatepickerProps, DatepickerValue } from './datepicker.types'

const formatDateList = (list: moment.Moment[]) => list.map((item) => item.format('YYYY-MM-DD'))
const isExistDate = (prevList: moment.Moment[], list: string[]) =>
    prevList.some((element) => {
        const formatDate = element.format('YYYY-MM-DD')
        return list.includes(formatDate)
    })

const DatepickerMethods = (p_: DatepickerProps): DatepickerMethodsResult => {
    const [list, setList] = useState<moment.Moment[]>([])

    useEffect(() => {
        if (p_.list && p_.list.length) {
            setList(p_.list)
        }
    }, [])
    const handleChange = (date: DatepickerValue) => {
        if (p_.list) {
            if (!moment.isMoment(date)) {
                return
            }

            const nextList = compareDates(date)

            p_.onChange(nextList)
            setList(nextList)
        } else {
            p_.onChange(date)
        }
    }
    const compareDates = (date: moment.Moment) => {
        let nextList = [...list]
        const dateFilter = formatDateList(nextList)
        const currentDate = date.format('YYYY-MM-DD')

        if (!dateFilter.includes(currentDate)) {
            nextList.push(date)
        } else {
            nextList = nextList.filter((prevDate) => prevDate.format('YYYY-MM-DD') !== currentDate)
        }

        return nextList
    }
    const handleWeekSelect = (date: Date) => {
        if (!p_.list) {
            return
        }

        let days: moment.Moment[] = []
        let start = moment(date).startOf('week')
        const end = moment(date).endOf('week')

        while (start <= end) {
            days.push(start)
            start = start.clone().add(1, 'd')
        }

        const minDate = p_.minDate

        if (minDate) {
            days = days.filter((day) => day.isAfter(minDate) || day.isSame(minDate, 'day'))
        }

        const formattedDays = formatDateList(days)

        if (!isExistDate(list, formattedDays)) {
            days = [...list, ...days]
        } else {
            days = list.filter((day) => !formattedDays.includes(day.format('YYYY-MM-DD')))
        }

        p_.onChange(days)
        setList(days)
    }

    return {
        s_list: list,
        handleWeekSelect,
        handleChange,
    }
}

export default DatepickerMethods
